import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { MsgTypeDownloadEnum } from '../file-download/enum/msgTypeDownload.enum';
import { UiLoadingModel } from '../loading/models/UiLoadingModel';
import { FileUploadFlowStateEnum } from './enum/file-upload-flow-state-enum';
import { MsgTypeUploadEnum } from './enum/msgTypeUpload.enum';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FileUploadComponent implements OnInit, OnChanges {

  @Output() userWantsUploadEvent = new EventEmitter<any>(); // file
  @Output() hasSelectedFile = new EventEmitter<boolean>(); // file
  @Input() backendResponse: any;

  MSG_TYPE_ENUM = MsgTypeUploadEnum;

  loadingModel: UiLoadingModel;
  msgType: MsgTypeDownloadEnum;
  flowState: FileUploadFlowStateEnum;
  FLOW_STATE = FileUploadFlowStateEnum;
  file: any;

  isDragEnter: boolean;
  isDragLeave: boolean;

  constructor() {
    this.file = null;
    this.msgType = null;
    this.flowState = FileUploadFlowStateEnum.UNSELECTED;
    this.isDragEnter = false;
    this.isDragLeave = false;
  }

  ngOnInit(): void {
    this.setDefaultLoading();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.backendResponse?.currentValue) {
      this.onUploadResponseHandler(this.backendResponse);
    }
  }

  setDefaultLoading(): void {
    const model = new UiLoadingModel();
    this.loadingModel = model;
  }

  // dragenter
  onDragEnter(event) {
    if (!this.isDragEnter) {
      this.isDragEnter = true;
      this.isDragLeave = false;
    }
  }

  // dragover
  onDragOver(event) {
    event.preventDefault();
  }

  // dragleave
  onDragLeave(evt) {
    this.isDragEnter = false;
    this.isDragLeave = true;
  }

  // drop
  onDrop(event) {
    event.preventDefault();
    this.isDragEnter = false;
    const files = event.dataTransfer.files;
    this.newFileHandler(files);
  }

  onUploadResponseHandler(backendResponse: any): void {
    const status: string = backendResponse?.status.toString();
    // is ok status like : 200, 201....
    if (status.startsWith('2')) {
      this.msgType = MsgTypeDownloadEnum.SUCCESS;
      this.onRemoveFile(true);
    } else {
      this.msgType = MsgTypeDownloadEnum.ERROR;
    }
    this.loadingModel.isLoading = false;
  }

  /* EVENTS */

  /**
   * On file selected
   */
  onChangeFileInput(files: any) {
    this.newFileHandler(files);
  }

  onClickBtn(): void {
    this.userWantsUploadEvent.next(this.file);
    this.loadingModel.isLoading = true;
  }

  onRemoveFile(keepMsg: boolean) {
    this.flowState = FileUploadFlowStateEnum.UNSELECTED;
    this.clearSelectedFile();
    if (!keepMsg) {
      this.msgType = null;
    }
    this.hasSelectedFile.next(false);
  }

  newFileHandler(files: any): void {
    const file = files[0];
    this.file = file;
    this.flowState = this.FLOW_STATE.SELECTED;
    this.hasSelectedFile.next(file);
  }

  clearSelectedFile(): void {
    this.file = null;
  }
}
